import type { AxiosError } from 'axios'
import type { AppInfoMessage } from 'BrokerTsLib/src/dtos'
import type { Product } from 'BrokerTsLib/src/enums'
import { useSaveAppInfoMessage } from 'BrokerTsLib/src/hooks/useAppInfoMessage'
import { useState } from 'react'
import { useNavigate, useSearchParams } from 'react-router'

import { AppInfoForm } from '@/components/AppInfo/AppInfoForm'
import {
  DashboardHeader,
  DashboardHeaderBackButton,
} from '@/containers/dashboard/DashboardHeader'
import { PageWrapper } from '@/layouts/components/PageWrapper'

export const NewsCreatePage = () => {
  const navigate = useNavigate()
  const [searchParams] = useSearchParams()
  const [product] = useState<Product | null>(
    searchParams.get('product') as Product | null,
  )

  const [appInfo] = useState<AppInfoMessage>({
    insuranceCategoryType: product,
    messageShow: true,
    messageImportance: 1,
  } as AppInfoMessage)

  const { mutateAsync: saveAppInfoAsync } = useSaveAppInfoMessage()

  const onSubmit = (value: AppInfoMessage) =>
    saveAppInfoAsync(value)
      .then((r) => {
        navigate('../admin')
        return r
      })
      .catch((e: AxiosError) => e)

  return (
    <PageWrapper
      header={
        <DashboardHeader title="Nová aktualita">
          <DashboardHeaderBackButton onClick={() => navigate('../admin')}>
            Zpět na správu aktualit
          </DashboardHeaderBackButton>
        </DashboardHeader>
      }
      mainProps={{
        sx: {
          pt: { base: 0, sm: 8 },
          gap: 4,
          display: 'grid',
          w: { base: '100%', sm: 'lg', lg: '4xl' },
          margin: '0 auto',
        },
      }}
    >
      <AppInfoForm appInfo={appInfo} onSubmit={onSubmit} />
    </PageWrapper>
  )
}
